import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';

const PurchaseOrderLine = ({ payload, purchaseOrderLines, adjustedTotal, setAdjustedTotal, taxSetting, shippingTotal, setShippingTotal, accountUnits }) => {
  const format = (value) => {
    return (accountUnits.currencyPrefix + (parseFloat(value) || 0).toFixed(parseInt(accountUnits.currencyPrecision)) + accountUnits.currencySuffix).replace('.', accountUnits.currencyDecimalSeparator);
  }

  const setTotal = (event) => {
    let value = event.target.value;
    setAdjustedTotal(value)
  }

  const setShipping = (event) => {
    let value = event.target.value;
    setShippingTotal(value)
  }

  const subtotal = () => {
    let subtotal = 0.0;

    purchaseOrderLines?.lineItems?.forEach(purchaseOrderLine => {
      let key = purchaseOrderLine.productId + '/' + purchaseOrderLine.variationId;
      let quantity = purchaseOrderLines.lineDetails[key].quantity;
      let unitPrice = purchaseOrderLines.lineDetails[key].adjustedUnitCost || purchaseOrderLine.supplier_price;
    
      subtotal = subtotal + (quantity * unitPrice);
    })

    return subtotal;
  }

  const taxes = () => {
    if(!taxSetting) {
      return 0.0;
    }

    let taxes = 0.0;

    purchaseOrderLines?.lineItems?.forEach(purchaseOrderLine => {
      let key = purchaseOrderLine.productId + '/' + purchaseOrderLine.variationId;
      let quantity = purchaseOrderLines.lineDetails[key].quantity;
      let unitPrice = purchaseOrderLines.lineDetails[key].adjustedUnitCost || purchaseOrderLine.supplier_price;
      let taxTotal = parseFloat(purchaseOrderLines.lineDetails[key].adjustedTax);

      if(taxTotal !== 0.0) {
        taxTotal = taxTotal || ((quantity * unitPrice) * (taxSetting?.rate || 0)/100.0);
      }

      taxes = taxes + taxTotal;
    })

    return taxes;
  }

  return(
    <div className="flex-1 text-right left-15">
      <div className="flex-container flex-column">
        <div className="flex-1">
          <strong>Subtotal</strong>: { format(subtotal()) }
        </div>
        <br/>

        <div className="flex-1">
          <strong>Taxes</strong>: { format(taxes()) }
        </div>

        <br/>


        <div className="fieldset">
          <div className="field field--medium field--filled">
            <span className="fieldset__svg-icon"></span>
            <label className="field__label">Shipping total</label>
            <input
              id="shipping_total" 
              type="number"
              min="0"
              value={ shippingTotal }
              onChange={(e) => setShipping(e)}
              className="field__input"
              onFocus={focus}
              onBlur={blur}
            />
            <div className="field__placeholder">Shipping total</div>
            <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
            <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
          </div>
          <div className="field__error" aria-hidden="true" style={{ display: 'none' }}></div>
        </div>


        <br/>
        

        <div className="flex-1">
          <strong>Total</strong>: { format(subtotal() + taxes() + (parseFloat(shippingTotal) || 0.0)) }
        </div>
      </div>

      <hr/>

      <div className="flex-container flex-column">
        <div className="fieldset">
          <div className="field field--medium field--filled">
            <span className="fieldset__svg-icon"></span>
            <label className="field__label">Adjusted total</label>
            <input 
              id="adjusted_total" 
              type="number"
              min="0"
              value={ adjustedTotal }
              onChange={(e) => setTotal(e)}
              className="field__input"
              onFocus={focus}
              onBlur={blur}
            />
            <div className="field__placeholder">Adjusted total</div>
            <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
            <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
          </div>
          <div className="field__error" aria-hidden="true" style={{ display: 'none' }}></div>
        </div>
      </div>

      
    </div>
  )

}

const mapStateToProps = state => ({
  accountUnits: state.accounts.account.store_details.formatsAndUnits,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderLine);